import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import MinusCircle from '@/images/icons/MinusCircle';
import LoaderIcon from '@/images/icons/Loader';
import CheckCircle from '@/images/icons/CheckCircle';

export function Alert({ isShow = false, status, children, absolute = false, id }: {
    isShow: boolean,
    status?: string,
    children?: React.ReactNode,
    absolute?: boolean,
    id?: string
}) {
    const [isShowLocal, setIsShowLocal] = useState(isShow);

    const isEmptyChildren = () => {
        let isEmpty = true;

        React.Children.forEach(children, (child) => {
            if (child) {
                isEmpty = false;
            }
        });

        return isEmpty;
    }

    const getIcon = () => {
        const loaderClassnames = classNames({
           'min-w-[14px] min-h-[14px] mr-[10px]': !isEmptyChildren(),
           'w-8 h-8': isEmptyChildren(),
        });

        if (status === 'error') {
            return <MinusCircle className="text-[#1A1C1D] min-w-[14px] min-h-[14px] mr-2" backgroundColor="#FF825B" />;
        }
        if (status === 'loading') {
            return <LoaderIcon className={`animate-rotation text-white ${loaderClassnames}`} />;
        }
        if (status === 'success') {
            return <CheckCircle className="text-white min-w-[14px] min-h-[14px] mr-2" backgroundColor="#3CBBCE" />;
        }

        return null;
    }

    const loadingStyles = classNames(
        {
            'pr-[14px] max-w-[60px]': (status === 'loading') && isEmptyChildren(),
            'pr-[50px]': (status === 'loading') && !isEmptyChildren(),
        }
    );

    const visibilityStyles = classNames(
        {
            'opacity-100': isShowLocal,
            'opacity-0': !isShowLocal,
        }
    );

    useEffect(() => {
        setIsShowLocal(isShow);
    }, [isShow, status]);

    useEffect(() => {
        let timeout: any = null;

        if (isShowLocal) {
            timeout = setTimeout(() => {
                setIsShowLocal(false);
            }, status === 'error' ? 4000 : 2000);
        }
        return () => {
            clearTimeout(timeout);
        }
    }, [isShowLocal, status]);

    return (
        <div id={id} className={classNames(
          'right-4 bottom-auto left-4 m-auto z-30 flex items-center text-white rounded-[8px] bg-[#1A1C1D] py-2.5 px-[14px] transition ease-out duration-200 text-sm/[1.2] pointer-events-none w-fit max-w-[288px]',
          absolute ? 'absolute' : 'fixed',
          absolute ? 'top-10': 'top-3',
          loadingStyles,
          visibilityStyles,
        )}>
            {getIcon()}
            {children}
        </div>
    );
}
